import { mapGetters } from 'vuex'
import { actionTypes, getterTypes, opcaoSimNao } from '@/core/constants'
import { AzBpmProcess } from '@azinformatica/loki'
import FluxoProcesskey from '@/core/constants/fluxo-processkey'

export default {
	emits: ['after-action'],
	data() {
		return {
			businessKey: `${this.$route.params.id}`,
			process_key: this.$store.getters[getterTypes.COMUM.GET_CAMUNDA_PROCESS_KEY](FluxoProcesskey.ADESAO),
			processInstance: {},
			process: null,
			componentes: null,
			botaoClasse: 'acessar-adesao-view__btn-bpm',
		}
	},
	computed: {
		...mapGetters({
			getCurrentTaskBpmn: getterTypes.COMUM.GET_CURRENT_TASK,
		}),
		temPermissao() {
			if (this.process) return this.process.hasAuthority()
			return false
		},
		temProximaTask() {
			const currentTask = this.getCurrentTaskBpmn(this.process_key, this.businessKey)
			return currentTask && currentTask.assignee && currentTask.nextTasks && currentTask.nextTasks.length > 0
		},
	},
	methods: {
		async actionAfterBpm(obj) {
			await this.exibirNotificacoes(obj)
			await this.atualizaInstanciaDoProcesso()
			this.$emit('after-action')
		},

		async exibirNotificacoes(resultadoAcao) {
			if (resultadoAcao.error) {
				this.mostrarNotificacaoErroFluxo(resultadoAcao.error)
			} else {
				this.mostrarNotificacaoSucessoDefault()
			}
		},

		mostrarNotificacaoErroFluxo(erro) {
			this.mostrarNotificacaoErro(erro.response?.data?.message || 'Erro desconhecido')
		},

		async atualizaInstanciaDoProcesso() {
			this.process = new AzBpmProcess(this.$store, this.process_key, this.businessKey)
			await this.process.load()
			this.processInstance = this.process.getProcess().instance
			this.componentes = this.process.getComponents()
		},
		buscarBotao(tipo) {
			if (this.componentes) {
				const { button } = this.componentes
				return button[tipo]
			}
			return null
		},
		getClassButton(tipo, classePadrao) {
			if (tipo === 'uncomplete') return 'd-none'
			let btnClaim = this.buscarBotao(tipo)
			if (btnClaim && !btnClaim.disabled) return classePadrao
			return 'd-none'
		},
		async tratarParametros(buttonType, bpmParameters) {
			let currentTask = this.getCurrentTaskBpmn(this.process_key, this.businessKey)
			let deveTrocarUO = currentTask.extensions.deveTrocarUoDestino
			if (buttonType === 'complete') {
				if (deveTrocarUO === opcaoSimNao.SIM.value) {
					let aux = bpmParameters.uoDestinationId
					let adesao = await this.$store.dispatch(actionTypes.ADESAO.BUSCAR_POR_ID, this.$route.params.id)
					if (aux === adesao.unidadeOrganizacional.id) {
						bpmParameters.uoOriginId = adesao.unidadeOrganizacional.id
						bpmParameters.uoDestinationId = adesao.ataRegistroPreco.orgaoGerenciador.id
					} else if (aux === adesao.ataRegistroPreco.orgaoGerenciador.id) {
						bpmParameters.uoOriginId = adesao.ataRegistroPreco.orgaoGerenciador.id
						bpmParameters.uoDestinationId = adesao.unidadeOrganizacional.id
					}
				}
			}

			return true
		},
	},
}
